import React from "react";

import { Skeleton } from "~/components/ui/skeleton";
import { formatCurrency } from "~/utils/helpers";

interface DebtSummaryCardsProps {
  totalDebt: number;
  prontoVencer: number;
  sana: number;
  vencida: number;
  loading?: boolean;
}

export const DebtSummaryCards: React.FC<DebtSummaryCardsProps> = ({
  totalDebt,
  prontoVencer,
  sana,
  vencida,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="flex items-center justify-between">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-6 w-24" />
          </div>
        ))}
      </div>
    );
  }

  const items = [
    {
      title: "Deuda total",
      amount: totalDebt,
      color: "text-red-600",
    },
    {
      title: "Deuda sana",
      amount: sana,
      color: "text-green-600",
    },
    {
      title: "Deuda pronto a vencer",
      amount: prontoVencer,
      color: "text-orange-600",
    },
    {
      title: "Deuda vencida",
      amount: vencida,
      color: "text-red-600",
    },
  ];

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div key={index} className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-700">
            {item.title}:
          </span>
          <span className={`text-lg font-bold ${item.color}`}>
            ${formatCurrency(item.amount)}
          </span>
        </div>
      ))}
    </div>
  );
};
